<template>
  <a-modal
    title="病种选择"
    :width="800"
    :visible="visible"
    switchFullscreen
    :footer="null"
    @cancel="handleCancel">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="病种名称">
              <j-input placeholder="请输入病种名称" v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="CODE">
              <j-input placeholder="请输入CODE" v-model="queryParam.code"></j-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="关键字">
              <j-input placeholder="请输入关键字" v-model="queryParam.keyword"></j-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleSelect(record)">选择</a>
        </span>

      </a-table>
    </div>
  </a-modal>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JInput from '@comp/jeecg/JInput.vue'

export default {
  name: "DiseaseSelect",
  mixins:[JeecgListMixin],
  components: {
    JInput,
  },
  data () {
    return {
      description: '',
      // 表头
      columns: [
        {
          title: '病种名称',
          align:"center",
          dataIndex: 'name'
        },
        {
          title: 'CODE',
          align:"center",
          dataIndex: 'code'
        },
        {
          title: '关键字',
          align:"center",
          dataIndex: 'keyword'
        },
        {
          title: '描述',
          align:"center",
          ellipsis: true,
          dataIndex: 'description',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align:"center",
          scopedSlots: { customRender: 'action' },
        }
      ],
      url: {
        list: "/tempconfig/tempConfigDisease/list",
      },
      visible:false,

    }
  },
  computed: {
  },
  methods: {
    handleSelect(record){
      this.$emit('handleSelect',record)
      this.handleCancel()
    },
    view(){
      this.visible = true
    },
    handleCancel(){
      this.visible = false
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>